import { render } from "./ProductInfo.vue?vue&type=template&id=d4282b90&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=d4282b90&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4282b90"],['__file',"resources/js/modules/product-categorization-drag-drop/components/filter/ProductInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4282b90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4282b90', __exports__)) {
    api.reload('d4282b90', __exports__)
  }
  
  module.hot.accept("./ProductInfo.vue?vue&type=template&id=d4282b90&scoped=true", () => {
    api.rerender('d4282b90', render)
  })

}


export default __exports__